import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ExtensionBadge from '~/components/atoms/ExtensionBadge';
import SidebarDesktop from '~/components/layouts/MainLayout/components/Sidebar/desktop';
import { SideBarItemType } from '~/core/sidebar';
import analytics from '~/services/analytics';
import extension from '~/services/Extension';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  sidebarGroups: SideBarItemType[][];
  children?: React.ReactNode;
};

const DesktopExtension: FC<Props> = ({ children, sidebarGroups }) => {
  const { t } = useTranslation('general');

  return (
    <div className={styles.layout}>
      <div className={styles.layout__sidebar}>
        <SidebarDesktop items={sidebarGroups} />
      </div>

      <div className={styles.layout__main}>
        <div className={styles.header}>
          <Typography
            variant={Typographies.TITLE_LARGE}
            component="div"
            className={styles.header__title}
          >
            {t('sidebar:extension_v1', {
              extension_name: extension.getTitle(),
              defaultValue: '{{extension_name}} Extension',
            })}
          </Typography>

          <ExtensionBadge
            text={t('general:enable_in_extension', {
              extension: extension.getTitle(),
              defaultValue: 'Enable in {{extension}}',
            })}
            onClick={() => {
              analytics.trackEvent(
                'navigation - click extension platform page',
                {
                  button_name: 'Enable in Chrome',
                },
              );
            }}
          />
        </div>

        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default DesktopExtension;
